import React, { useState, forwardRef } from "react";
import "../../pages/invoiceList/invoice.scss";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];
// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
  ></input>
));
// datepicker end

const SubAddNewInvoice = () => {
  const [startDate, setStartDate] = useState(new Date());

  const [distributertag, setDistributerTag] = useState([]);
  const handleChange = (selected) => {
    setDistributerTag(selected);
  };
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Customer Name <span className="mandatory">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Customer Name"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Contact Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Contact Number"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Email Address</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Email Address"
                ></input>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>
                      Customer LPO <span className="mandatory">*</span>
                    </label>
                    <ReactSelect
                      className="basic-multi-select"
                      options={colourOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option,
                      }}
                      onChange={handleChange}
                      allowSelectAll={true}
                      value={distributertag}
                      placeholder="Customer LPO"
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral80: "#000000",
                        },
                      })}
                    />
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>
                      Sales Engineer <span className="mandatory">*</span>
                    </label>
                    <ReactSelect
                      className="basic-multi-select"
                      options={colourOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option,
                      }}
                      onChange={handleChange}
                      allowSelectAll={true}
                      value={distributertag}
                      placeholder="Sales Engineer"
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral80: "#000000",
                        },
                      })}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>Division</label>
                    <ReactSelect
                      className="basic-multi-select"
                      options={colourOptions}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      components={{
                        Option,
                      }}
                      onChange={handleChange}
                      allowSelectAll={true}
                      value={distributertag}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          neutral80: "#000000",
                        },
                      })}
                    />
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                  <div>
                    <label>
                      Invoice Ref <span className="mandatory">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Invoice Reference"
                    ></input>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Customer Address <span className="mandatory">*</span>
                </label>
                <textarea
                  className="form-control"
                  placeholder="Enter Customer Address"
                  rows="5"
                ></textarea>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Invoice Type <span className="mandatory">*</span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={distributertag}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div className="set-expiry-date">
                <label>Invoice Date</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  customInput={<ExampleCustomInput />}
                  dayClassName={() => "example-datepicker-day-class"}
                  popperClassName="example-datepicker-class"
                  todayButton="TODAY"
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Credit Days</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Invoice Reference"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>
                  Delivery Notes <span className="mandatory"></span>
                </label>
                <ReactSelect
                  className="basic-multi-select"
                  options={colourOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{
                    Option,
                  }}
                  onChange={handleChange}
                  allowSelectAll={true}
                  value={distributertag}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      neutral80: "#000000",
                    },
                  })}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
              <div>
                <div>
                  <label>
                    Payment Terms <span className="mandatory">*</span>
                  </label>
                  <ReactSelect
                    className="basic-multi-select"
                    options={colourOptions}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                      Option,
                    }}
                    onChange={handleChange}
                    allowSelectAll={true}
                    value={distributertag}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        neutral80: "#000000",
                      },
                    })}
                  />
                </div>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div className="set-expiry-date">
                <label>Payment Due Date</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                  customInput={<ExampleCustomInput />}
                  dayClassName={() => "example-datepicker-day-class"}
                  popperClassName="example-datepicker-class"
                  todayButton="TODAY"
                />
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div className="d-flex mt-30">
                <div className="custom-control custom-checkbox custom-checkbox-blue mr-3">
                  <input
                    type="checkbox"
                    className="custom-control-input custom-control-input-blue"
                    id="colorCharges"
                  />
                  <label
                    className="custom-control-label pt-1"
                    for="colorCharges"
                  >
                    Color Charges
                  </label>
                </div>
                <div className="custom-control custom-checkbox custom-checkbox-blue">
                  <input
                    type="checkbox"
                    className="custom-control-input custom-control-input-blue"
                    id="verified"
                  />
                  <label className="custom-control-label pt-1" for="verified">
                    Verified
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card mt-3">
        <div className="card-body">
          <div className="row">
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Total Quantity</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Total Quantity"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Total Amount</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Total Amount"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Order Charges</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Order Charges"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Discount</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Discount"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Other Charges</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Other Charges"
                ></input>
              </div>
            </div>
            <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
              <div>
                <label>Net Total</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Net Total"
                ></input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
          <div className="save-btns">
            <button type="button" className="btn cancel-btn mr-3">
              Cancel
            </button>
            <button
              type="button"
              className="btn save-btn"
              data-toggle="modal"
              data-target="#saveSuccessModal"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubAddNewInvoice;
